export const CONTENT_COLLECTION_ROUTE_NAME = 'content.collection';
export const CONTENT_COLLECTION_DETAIL_ROUTE_NAME = 'content.collection.detail';

export { CONTENT_ROUTE_NAME as CONTENT_PAGE_SCOPE_ID } from '#layers/spaces/constants/project-routes';
